import React, { FunctionComponent } from 'react'
import { Accordion } from '@afterpaytouch/core'

import styles from './styles.module.css'
import { useDetailedItemViewModel } from './useDetailedItemViewModel'
import { ItemHeader } from './ItemHeader'
import { FinancingSummary } from './components/FinancingSummary'
import { FinancingDetails } from './components/FinancingDetails'
import { useTranslation } from '../../../../utils/convergence'

interface ItemProps {
  id: string
}

export const Item: FunctionComponent<ItemProps> = ({ id }) => {
  const { primaryData, childData, primaryAmountPlusChildAmount, schedules, hasInterestAmount, hasDownpayment, isPayInFull } = useDetailedItemViewModel(id)
  const { t } = useTranslation(['summary'])

  if (typeof primaryData === 'undefined') {
    return null
  }

  return (
    <li className={styles.item}>
      <Accordion id={`line-item-financing-${id}`} verticalAlignLabel disabled={isPayInFull} caret={isPayInFull ? null : undefined} accessoryPosition={'Bottom'}>
        <Accordion.Button>
          <ItemHeader
            id={id}
            name={primaryData.name}
            price={primaryData.price}
            secondaryPrice={childData?.price}
            strikeThroughPrice={primaryAmountPlusChildAmount}
            showAsterisk={typeof childData !== 'undefined'}
            isPayInFull={isPayInFull}
          />

          <FinancingSummary
            apr={primaryData.apr}
            interestAmount={primaryData.interestAmount}
            monthlyAmount={primaryData.monthlyAmount}
            numberOfInstallments={primaryData.numberOfInstallments}
            hasInterestAmount={hasInterestAmount}
            isPayInFull={isPayInFull}
          />
        </Accordion.Button>

        {!isPayInFull && (
          <Accordion.Details>
            <FinancingDetails
              id={id}
              name={primaryData.name}
              schedules={schedules}
              numberOfInstallments={primaryData.numberOfInstallments}
              hasDownpayment={hasDownpayment}
              downPaymentAmount={primaryData.downPaymentAmount}
              monthlyAmount={primaryData.monthlyAmount}
              showTradeInDisclaimer={typeof childData !== 'undefined'}
            />
          </Accordion.Details>
        )}
      </Accordion>
    </li>
  )
}
